import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   categories:null,
   services:null,
};

// getters
const getters = {
   serviceCategoryById:(state) => (categoryId) => {
      if (!state.categories) return;
      return state.categories.find((category)=>{
         if (category.id === categoryId) return true;
         else return false;
      });
   }
};

// actions
const actions = {
	SERVICE_CATEGORIES_GET:(context, {})=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/service-categories')
         .then((res)=>{
            context.commit('SERVICE_CATEGORIES_SET', {recs: res.data});
            resolve();
         })
         .catch((error)=>{
            console.log('error:',error)
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('service',error)});
            reject(error);
         });
      });
   },
   SERVICES_CLEAR:(context, {categoryId})=>{
      context.commit('SERVICES_CLEAR', {categoryId});
   },
   SERVICES_GET:(context, {categoryId})=>{
      return new Promise((resolve, reject)=>{
         let url =  '/api/services';
         if (categoryId) url += `?category_id=${categoryId}` 

         api.get(url)
         .then((res)=>{
            context.commit('SERVICES_SET', {recs: res.data});
            resolve();
         })
         .catch((error)=>{
            console.log('error:',error)
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('service',error)});
            reject(error);
         });
      });
   },
   SERVICE_INQUIRY_SEND:async (context, {inquiry})=>{
      /*
      {
        // system generated
        "id": 123, 
        // category describes the category associated with the inquiry
        // note: either category.id or service.id MUST be set
        "category": [...service category...],
        // service describes the service associated with the inquiry
        // note: either category.id or service.id MUST be set
        "service": [...service...]
        // user describes the user associated with the request. Optional.
        "user": [...user...]
        // email is the contact email associated with the request. Required.
        "email": "alex@scoutred.com",
        // phone is the contact phone number associated with the request. Optional.
        "phone": "alex@scoutred.com",
        // description of the service the user is looking for. Required.
        "description": "What I'm looking to achieve",
        // parcel_id is the ID of the parcel associated with the inquiry. Optional
        "parcel": [...parcel...],
        // system generated
        "created": "2019-11-13T16:10:35.677388-08:00", 
        // system generated
        "updated": "2019-11-13T16:10:35.677388-08:00"
      }

      */
      return await api.post('/api/service-inquiries', inquiry);
   },
};

// mutations
const mutations = {
   SERVICE_CATEGORIES_SET: (state, {recs})=>{
   	state.categories = recs;
   },
   SERVICES_CLEAR: (state, {categoryId})=>{
      state.services = null;
   },
   SERVICES_SET: (state, {recs})=>{
      state.services = recs;
   },
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/service.js